import React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { ScrollArea } from '@/components/ui/scroll-area';
import { Badge } from '@/components/ui/badge';
import { WidgetProps } from '@/lib/widgets/types';
import { Clock, FileText, Car, User, CheckCircle } from 'lucide-react';
import { formatDistanceToNow } from 'date-fns';
import { ptBR } from 'date-fns/locale';

export function RecentActivitiesWidget({ isEditing = false }: WidgetProps) {
  const activities = [
    {
      id: 1,
      type: 'invoice',
      title: 'NFe #234 emitida',
      description: 'R$ 1.250,00 - Cliente ABC Ltda',
      timestamp: new Date(Date.now() - 15 * 60 * 1000),
      icon: FileText,
      color: 'bg-blue-100 text-blue-600'
    },
    {
      id: 2,
      type: 'fleet',
      title: 'Veículo ABC-1234 adicionado',
      description: 'Caminhão Mercedes-Benz',
      timestamp: new Date(Date.now() - 45 * 60 * 1000),
      icon: Car,
      color: 'bg-green-100 text-green-600'
    },
    {
      id: 3,
      type: 'user',
      title: 'Novo usuário cadastrado',
      description: 'João Silva - Motorista',
      timestamp: new Date(Date.now() - 2 * 60 * 60 * 1000),
      icon: User,
      color: 'bg-purple-100 text-purple-600'
    },
    {
      id: 4,
      type: 'maintenance',
      title: 'Manutenção concluída',
      description: 'Troca de óleo - ABC-5678',
      timestamp: new Date(Date.now() - 4 * 60 * 60 * 1000),
      icon: CheckCircle,
      color: 'bg-emerald-100 text-emerald-600'
    }
  ];

  return (
    <Card className="h-full">
      <CardHeader className="pb-3">
        <CardTitle className="text-sm font-medium flex items-center gap-2">
          <Clock className="h-4 w-4" />
          Atividades Recentes
        </CardTitle>
      </CardHeader>
      <CardContent>
        <ScrollArea className="h-32">
          <div className="space-y-3">
            {activities.map((activity) => (
              <div key={activity.id} className="flex items-start gap-3">
                <div className={`p-1.5 rounded-full ${activity.color}`}>
                  <activity.icon className="h-3 w-3" />
                </div>
                <div className="flex-1 min-w-0">
                  <p className="text-sm font-medium truncate">{activity.title}</p>
                  <p className="text-xs text-muted-foreground truncate">{activity.description}</p>
                  <p className="text-xs text-muted-foreground">
                    {formatDistanceToNow(activity.timestamp, { addSuffix: true, locale: ptBR })}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </ScrollArea>
      </CardContent>
    </Card>
  );
}